export default {
  data() {
    return {
      controlLoading: false,
      dimIndex: ['M', 'A', 'B', 'C', 'D'],
      dialogOpt: {
        title: "-",
        relaystatus: false,
        dimSchedule: {
          ms: '',
          me: '',
          ml: '',
          as: '',
          ae: '',
          al: '',
          bs: '',
          be: '',
          bl: '',
          cs: '',
          ce: '',
          cl: '',
          ds: '',
          de: '',
          dl: ''
        },
        dimScheduleIndex: 1,
        dimScheduleEnabled: true,
        maintenance: false,
        kwhRate: 0,
        timeOn: '',
        timeOff: '',
        energyMeter: 0,
        timesyncStatus: false,
        brightness: 0,
        reportingInterval: 0,
        luxmax: 0,
        luxmin: 0,
        relayNotes: '',
        totalisatorNotes: '',
        timesyncNotes: '',
        maintenanceNotes: '',
        intervalNotes: '',
      }
    }
  },
  methods: {
    async controlRelay(devicecode, state, notes, silent = false) {
      console.log(devicecode, state, notes);
      this.controlLoading = true
      const payload = {
        devicecode,
        state,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setRelay",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.relayNotes;
      return { code, data, message };
    },

    async requestCurrentData(devicecode, silent = false) {
      this.controlLoading = true
      console.log('requestCurrentData', devicecode);
      const payload = {
        devicecode
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/requestCurrentData",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      return { code, data, message };
    },

    async controlKwhRate(devicecode, kwhRate, silent = false) {
      this.controlLoading = true
      console.log(devicecode, kwhRate);
      const payload = {
        devicecode,
        kwhRate
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setKwhRate",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      return { code, data, message };
    },

    async updateMaintenance(devicecode, maintenance, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, maintenance, notes);
      const payload = {
        devicecode,
        maintenance,
        notes
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/updateMaintenance",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
          try {
            const currentFilter = this.$store.getters["devices/currentFilter"] || { status: 'all' };
            await this.$store.dispatch("devices/refreshDeviceTree", currentFilter);
          } catch (error) {
            console.error("Failed to refresh device tree after maintenance update:", error);
          }
        } else {
          alert(message);
        }
      }
      if (!silent) {
        this.dialogOpt.maintenanceNotes = '';
      }
      return { code, data, message };
    },

    async controlBrightness(devicecode, brightness, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, brightness, notes);
      const payload = {
        devicecode,
        brightness,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setBrightness",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.relayNotes;
      return { code, data, message };
    },

    async controlTimeSync(devicecode, syncStatus, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, syncStatus, notes);
      const payload = {
        devicecode,
        syncStatus,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setTimeSync",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.timesyncNotes;
      return { code, data, message };
    },

    async controlSchedule(devicecode, timeOn, timeOff, notes, silent = false) {
      console.log('control--schedule')
      this.controlLoading = true
      console.log(devicecode, timeOn, timeOff, notes);
      const payload = {
        devicecode,
        timeOn,
        timeOff,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setSchedule",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.relayNotes;
      return { code, data, message };
    },

    async controlTotalisator(devicecode, totalisator, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, totalisator, notes);
      const payload = {
        devicecode,
        totalisator,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setTotalisator",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.totalisatorNotes;
      return { code, data, message };
    },

    async controlSendInterval(devicecode, reportingInterval, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, reportingInterval, notes);
      const payload = {
        devicecode,
        reportingInterval,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setSendInterval",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.intervalNotes;
      return { code, data, message };
    },

    async controlDriverModel(devicecode, silent = false) {
      this.controlLoading = true
      console.log(devicecode);
      const payload = {
        devicecode
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/getDriverModel",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      return { code, data, message };
    },

    async controlDeviceConfig(devicecode, silent = false) {
      this.controlLoading = true
      console.log(devicecode);
      const payload = {
        devicecode
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/getDeviceConfig",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      return { code, data, message };
    },

    async controlSendThreshold(devicecode, luxmax, luxmin, notes, silent = false) {
      this.controlLoading = true
      console.log(devicecode, luxmax, luxmin, notes);
      const payload = {
        devicecode,
        luxmax,
        luxmin,
        notes,
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setThreshold",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(data.message);
          this.dialog = false;
        } else {
          alert(message);
        }
      }
      delete this.dialogOpt.thresholdNotes;
      return { code, data, message };
    },

    async updateDimSchedule(devicecode, dimSchedule, silent = false) {
      this.controlLoading = true
      console.log(devicecode, dimSchedule);

      // Validate dimSchedule data
      if (!dimSchedule || !dimSchedule.ms || !dimSchedule.me) {
        this.controlLoading = false
        if (!silent) alert('Invalid dimming schedule data: Missing required fields')
        return { code: 400, message: 'Invalid dimming schedule data: Missing required fields' }
      }

      const payload = {
        devicecode,
        dimSchedule,
        index: this.dialogOpt.dimScheduleIndex || 1,
        enabled: this.dialogOpt.dimScheduleEnabled !== false
      };
      const { code, data, message } = await this.$store.dispatch(
        "devices/setDimSchedule",
        payload
      );
      this.controlLoading = false
      if (!silent) {
        if (code == 200) {
          alert(`Dimming schedule updated successfully: ${data.message}`);
          this.dialog = false;
        } else {
          alert(`Failed to update dimming schedule: ${message}`);
        }
      }
      return { code, data, message };
    },

    loadDimScheduleData() {
      // Priority 1: detailData (often set in List View or Dashboard on certain actions)
      // Priority 2: store/singleDevice (API detailed result)
      // Priority 3: deviceData (Tree node data)
      const dataSources = [
        { name: 'detailData', data: this.detailData },
        { name: 'storeSingleDevice', data: this.$store.getters["devices/singleDevice"] },
        { name: 'deviceData', data: this.deviceData }
      ];

      console.log('loadDimScheduleData: Scanning multiple sources...');

      // Helper to find valid schedule keys in an object
      const findValidSource = (source) => {
        if (!source || typeof source !== 'object') return null;

        const subSources = [
          { name: 'deviceconfig', data: source.deviceconfig },
          { name: 'devicedata', data: source.devicedata },
          { name: 'root', data: source }
        ];

        for (const sub of subSources) {
          if (!sub.data) continue;

          let obj = sub.data;
          if (typeof obj === 'string') {
            try {
              obj = JSON.parse(obj);
            } catch (e) { continue; }
          }

          if (obj && typeof obj === 'object') {
            // Hyper-robust check: Use 'in' to see if keys exist, even if value is empty/null/0
            // Backend uses main_start/a_start etc. Form uses ms/as etc.
            const keysToCheck = ['main_start', 'ms', 'a_start', 'as', 'main_level', 'ml'];
            const hasProperty = keysToCheck.some(key => key in obj);

            if (hasProperty) {
              console.log(`loadDimScheduleData: Found valid keys in ${sub.name}`);
              return obj;
            }
          }
        }
        return null;
      };

      let configSource = null;
      for (const src of dataSources) {
        if (src.data) {
          configSource = findValidSource(src.data);
          if (configSource) {
            console.log(`loadDimScheduleData: Using source [${src.name}]`);
            break;
          }
        }
      }

      // Fallback to whichever we have if no specific schedule keys found
      if (!configSource) {
        configSource = this.detailData || this.$store.getters["devices/singleDevice"] || this.deviceData || {};
        console.warn('loadDimScheduleData: No specific schedule source found, using fallback.');
      }

      // Initialize dimSchedule if missing
      if (!this.dialogOpt.dimSchedule) {
        this.$set(this.dialogOpt, 'dimSchedule', {});
      }

      // Mapping
      for (let xi of this.dimIndex) {
        const prefix = xi.toLowerCase();
        const dbPrefix = prefix === 'm' ? 'main' : prefix;

        // inclusive lookup
        const sVal = configSource[`${dbPrefix}_start`] !== undefined ? configSource[`${dbPrefix}_start`] : (configSource[`${prefix}s`] || '');
        const eVal = configSource[`${dbPrefix}_end`] !== undefined ? configSource[`${dbPrefix}_end`] : (configSource[`${prefix}e`] || '');
        const lVal = configSource[`${dbPrefix}_level`] !== undefined ? configSource[`${dbPrefix}_level`] : (configSource[`${prefix}l`] || '');

        this.$set(this.dialogOpt.dimSchedule, `${prefix}s`, sVal);
        this.$set(this.dialogOpt.dimSchedule, `${prefix}e`, eVal);
        this.$set(this.dialogOpt.dimSchedule, `${prefix}l`, lVal);
      }
      console.log('Final loaded dimSchedule:', this.dialogOpt.dimSchedule);
    },

    // Method untuk MultiDeviceDashboard
    async controlSingle(dialogName, dialogOpt, deviceCode) {
      console.log('controlSingle', dialogName)
      switch (dialogName) {
        case "relaystatus":
          await this.controlRelay(
            deviceCode,
            dialogOpt.relaystatus,
            dialogOpt.relayNotes
          );
          break;
        case "currentdata":
          this.requestCurrentData(
            deviceCode
          );
          break;
        case "kwh_rate":
          await this.controlKwhRate(
            deviceCode,
            dialogOpt.kwhRate
          );
          break;
        case "maintenance":
          await this.updateMaintenance(
            deviceCode,
            dialogOpt.maintenance,
            dialogOpt.maintenanceNotes
          );
          break;
        case "schedule":
          this.controlSchedule(
            deviceCode,
            dialogOpt.timeOn,
            dialogOpt.timeOff,
            dialogOpt.relayNotes
          );
          break;
        case "newdimschedule":
          this.updateDimSchedule(
            deviceCode,
            dialogOpt.dimSchedule
          );
          break;
        case "brightness":
          await this.controlBrightness(
            deviceCode,
            dialogOpt.brightness,
            dialogOpt.relayNotes
          );
          break;
        case "timesync":
          await this.controlTimeSync(
            deviceCode,
            dialogOpt.timesyncStatus,
            dialogOpt.timesyncNotes
          );
          break;
      }
    },

    // Method untuk ListView
    processRealtimeControl(dialogName, dialogOpt) {
      console.log("prc", dialogName, dialogOpt);
      const devicecode = this.detailData.devicecode;

      switch (dialogName) {
        case "relaystatus":
          this.controlRelay(
            devicecode,
            dialogOpt.relaystatus,
            dialogOpt.relayNotes
          );
          break;
        case "currentdata":
          this.requestCurrentData(devicecode);
          break;
        case "kwh_rate":
          this.controlKwhRate(
            devicecode,
            dialogOpt.kwhRate
          );
          break;
        case "maintenance":
          this.updateMaintenance(
            devicecode,
            dialogOpt.maintenance,
            dialogOpt.maintenanceNotes
          );
          break;
        case "schedule":
          this.controlSchedule(
            devicecode,
            dialogOpt.timeOn,
            dialogOpt.timeOff,
            dialogOpt.relayNotes
          );
          break;
        case "totalisator":
          this.controlTotalisator(
            devicecode,
            dialogOpt.energyMeter,
            dialogOpt.totalisatorNotes
          );
          break;
        case "timesync":
          this.controlTimeSync(
            devicecode,
            dialogOpt.timesyncStatus,
            dialogOpt.timesyncNotes
          );
          break;
        case "brightness":
          this.controlBrightness(
            devicecode,
            dialogOpt.brightness,
            dialogOpt.relayNotes
          );
          break;
        case "interval":
          this.controlSendInterval(
            devicecode,
            dialogOpt.reportingInterval,
            dialogOpt.intervalNotes
          );
          break;
        case "driver_model":
          this.controlDriverModel(devicecode);
          break;
        case "device_config":
          this.controlDeviceConfig(devicecode);
          break;
        case "set_threshold":
          this.controlSendThreshold(
            devicecode,
            dialogOpt.luxmax,
            dialogOpt.luxmin,
            dialogOpt.intervalNotes
          );
          break;
        case "newdimschedule":
          this.updateDimSchedule(
            devicecode,
            dialogOpt.dimSchedule
          );
          break;
      }
    }
  }
}
